import { styled } from '@mui/system';
import { FC, ReactNode } from 'react';

const PageContainer = styled(`div`)(() => ({
  pageContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    paddingBottom: '24px',
  },
}));

export const StepContainer: FC<{ children: ReactNode }> = (props) => {
  return <PageContainer>{props.children}</PageContainer>;
};
